import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import CoursesTranslateView from "../../views/translate/CoursesTranslateView";
import i18n from "../../../../i18n";
import { route } from "../../../../routes";
import {
  FormUtility,
  withAuthentication,
  withCoursePortalApi,
  withTranslationApi,
} from "cw-styleguide-react";

import withAssets from "../../../../components/hoc/withAssets";
import {
  TRANSLATOR_UNASSIGNED,
  TAB_COURSE_SESSIONS,
  TAB_COURSE_DETAILS,
  STEP_SESSION_DETAILS,
  STEP_SESSION_VIEW,
  STEP_SESSION_VENUES,
  LANGUAGE_EN,
  LANGUAGE_CY,
} from "../../../../constants";
import withAuditApi from "../../../../apis/withAuditApi";

class CoursesTranslateController extends Component {
  /**
   * constructor.
   * @param props
   */
  constructor(props) {
    super(props);

    // State.
    this.state = {
      values: {},
      originalValues: {},
      formErrors: {},
      audit: {},
      modals: {
        assign: false,
        bulkAssign: false,
        unassign: false,
        bulkUnassign: false,
      },
      translatableFields: [],
      loaded: false,
      messages: new Set(),
      redirect: null,
      selected: new Set(),
      errorActiveTab: null,
      reloadKey: Math.random(),
      query: ''
    };

    // Binding.
    this.loadCourse = this.loadCourse.bind(this);
    this.saveCourse = this.saveCourse.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSetFormValue = this.handleSetFormValue.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.assignCourse = this.assignCourse.bind(this);
    this.compareCourse = this.compareCourse.bind(this);
    this.setReloadKey = this.setReloadKey.bind(this);
    this.handleBulkCheckbox = this.handleBulkCheckbox.bind(this);
    this.clearMessages = this.clearMessages.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.clearRedirect = this.clearRedirect.bind(this);
    this.handleErrorClick = this.handleErrorClick.bind(this);
    this.handleClearActiveErrors = this.handleClearActiveErrors.bind(this);
    this.translateCourseAll = this.translateCourseAll.bind(this);
    this.translateCourseField = this.translateCourseField.bind(this);
    this.loadAudit = this.loadAudit.bind(this);
    this.setQuery = this.setQuery.bind(this);
  }

  /**
   * setQuery
   * @param value
   */
  setQuery(value) {
    this.setState({
      query: value,
    });
  }

  /**
   * loadAudit
   * @param id
   */
  loadAudit(id) {
    this.props.auditApiGetAudit(
      id,
      "coursePortal",
      i18n.language,
      (response) => {
        this.setState({
          audit: response.data,
        });
      },
      (error) => {
        this.setState({
          audit: false,
        });
      }
    );
  }

  /**
   * Set a new reload key forcing a page refresh.
   */
  setReloadKey() {
    this.setState({
      reloadKey: Math.random(),
    });
  }

  /**
   * clearSelected
   */
  clearSelected() {
    this.setState({
      selected: new Set(),
    });
  }

  /**
   * clearMessages
   */
  clearMessages() {
    this.setState({
      messages: new Set(),
      formErrors: {},
    });
  }

  /**
   * clearSelected
   */
  clearRedirect() {
    this.setState({
      redirect: null,
    });
  }

  /**
   * loadCourse
   * @param id
   */
  loadCourse(id) {
    this.setState({
      loaded: false,
    });
    this.props.coursePortalApiGetCourse(
      id,
      i18n.language,
      (response) => {
        this.setState({
          values: response.data,
          originalValues: JSON.parse(JSON.stringify(response.data)), // clone
          loaded: true,
        });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          loaded: false,
        });
      }
    );
  }

  /**
   * saveCourse
   * @param status
   */
  saveCourse(status) {
    let payload = this.props.coursePortalApiPrepareCourse(this.state.values);
    payload.status = status;

    this.props.coursePortalApiPostCourse(
      payload,
      i18n.language,
      (response) => {
        // Save the current state of messages.
        let messages = new Set();

        messages.add({
          type: "positive",
          message: i18n.t(
            "local:view.courses.status." + response.data.status + ".success",
            { id: response.data.id }
          ),
        });

        this.setState({
          formErrors: [],
          redirect: route("coursesTranslateManage") + this.state.query,
        });

        // Set the messages.
        this.setState({ messages: messages });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  /**
   * assignCourse
   * @param ids
   * @param translator
   */
  assignCourse(ids, translator) {
    this.props.coursePortalApiAssignTranslator(
      ids,
      translator,
      i18n.language,
      (response) => {
        let messages = new Set();

        this.toggleModal(
          ["assign", "bulkAssign", "unassign", "bulkUnassign"],
          false
        );

        if (translator === TRANSLATOR_UNASSIGNED) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courses.manage.messages.unassign." +
                (response.data.courseIds.length === 1 ? "singular" : "plural"),
              { count: response.data.courseIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courses.manage.messages.assign." +
                (response.data.courseIds.length === 1 ? "singular" : "plural"),
              { count: response.data.courseIds.length }
            ),
          });
        }

        this.setState({
          formErrors: [],
          messages: messages,
          selected: new Set(),
          redirect: route("coursesTranslateManage") + this.state.query,
        });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);

        this.toggleModal(
          ["assign", "bulkAssign", "unassign", "bulkUnassign"],
          false
        );
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  /**
   * compareCourse
   * @param courseId
   */
  compareCourse(courseId) {
    this.props.coursePortalApiCompareCourses(
      courseId,
      i18n.language,
      (response) => {
        this.setState({
          translatableFields: response.data.fields ? response.data.fields : [],
        });
      },
      (error) => {
        // @todo what to do here?
      }
    );
  }

  /**
   * handleChange
   * @param event
   */
  handleChange(event) {
    let values = { ...this.state.values };
    this.setState({
      values: FormUtility.setFormValues(event, values),
    });
  }

  /**
   * handleSetFormValue.
   * @param field
   * @param value
   */
  handleSetFormValue(field, value) {
    const values = { ...this.state.values };

    FormUtility.setDeepValue(values, field, value, "set");
    this.setState({
      values: values,
    });
  }

  /**
   * toggleModal
   * @param id
   */
  toggleModal(ids, visiblity) {
    const modals = { ...this.state.modals };

    // loop through the ids.
    ids.forEach((id) => {
      modals[id] = visiblity;
    });

    this.setState({
      modals: modals,
    });
  }

  /**
   * handleBulkCheckbox
   * @param event
   */
  handleBulkCheckbox(event) {
    const selected = this.state.selected;
    if (selected.has(event.target.value)) {
      selected.delete(event.target.value);
    } else {
      selected.add(event.target.value);
    }
    this.setState({
      selected: selected,
    });
  }

  handleErrorClick(e, field) {
    // // Find instances of [] in field.
    // const matchedIndexes = field.match(/\[(.*?)\]/);

    let index = null;
    // if (matchedIndexes) {
    //   // Save the index associated with the error.
    //   index = matchedIndexes[1];

    //   // Strip index from field string.
    //   field = field.replace(matchedIndexes[0], '');
    // }

    field = field.split(".");

    // Save the index.
    field.forEach((fragment) => {
      if (!isNaN(fragment)) {
        index = parseInt(fragment);
      }
    });

    // Remove indexes from field name.
    field = field.filter((fragment) => isNaN(fragment));
    field = field.join(".");

    switch (field) {
      case "title_en":
      case "title_cy":
      case "abbreviatedTitle_en":
      case "abbreviatedTitle_cy":
      case "courseGroup.id":
      case "reviewDate":
      case "summary_en":
      case "summary_cy":
      case "content_en":
      case "content_cy":
      case "duration_en":
      case "duration_cy":
      case "entry_en":
      case "entry_cy":
      case "enrolment_en":
      case "enrolment_cy":
      case "cost_en":
      case "cost_cy":
        this.setState({
          errorActiveTab: TAB_COURSE_DETAILS,

          inputLanguage: field.includes("_cy") ? "cy" : "en",
        });
        break;

      case "sessions":
        if (index) {
          this.setState({
            errorActiveTab: TAB_COURSE_SESSIONS,
            errorActiveSessionStep: STEP_SESSION_DETAILS,
            errorActiveSessionId: index,

            inputLanguage: field.includes("_cy") ? "cy" : "en",
          });
        } else {
          this.setState({
            errorActiveTab: TAB_COURSE_SESSIONS,
            errorActiveSessionStep: STEP_SESSION_VIEW,
            errorActiveSessionId: index,

            inputLanguage: field.includes("_cy") ? "cy" : "en",
          });
        }
        break;

      case "sessions.startDate":
      case "sessions.startDetails_en":
      case "sessions.startDetails_cy":
      case "sessions.daysTimes_en":
      case "sessions.daysTimes_cy":
      case "sessions.studyMethodType":
        this.setState({
          errorActiveTab: TAB_COURSE_SESSIONS,
          errorActiveSessionStep: STEP_SESSION_DETAILS,
          errorActiveSessionId: index,

          inputLanguage: field.includes("_cy") ? "cy" : "en",
        });
        break;

      case "sessions.venues.id":
        this.setState({
          errorActiveTab: TAB_COURSE_SESSIONS,
          errorActiveSessionStep: STEP_SESSION_VENUES,
          errorActiveSessionId: index,

          inputLanguage: field.includes("_cy") ? "cy" : "en",
        });
        break;

      default:
        break;
    }
  }

  handleClearActiveErrors() {
    // Clear active errors before reassignment.
    this.setState({
      errorActiveTab: null,
      errorActiveSessionStep: null,
      errorActiveSessionId: null,
      errorActiveQualificationStep: null,
      errorActiveQualificationId: null,
    });
  }

  /**
   * translateCourseField
   * @param event
   * @param field
   */
  translateCourseField(event, field) {
    event.preventDefault();
    this.props.translationApiPostTranslation(
      "en",
      "cy",
      [
        {
          key: field,
          value: FormUtility.getDeepValue(this.state.values, field + ".en"),
        },
      ],
      i18n.language,
      (response) => {
        if (response.data[0].key !== null) {
          this.handleSetFormValue(field + ".cy", response.data[0].value);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  /**
   * translateCourseAll
   * @param event
   */
  translateCourseAll(event) {
    event.preventDefault();

    let data = [
      {
        key: "title",
        value: this.state.values["title"][LANGUAGE_EN],
      },
      {
        key: "abbreviatedTitle",
        value: this.state.values["abbreviatedTitle"][LANGUAGE_EN],
      },
      {
        key: "summary",
        value: this.state.values["summary"][LANGUAGE_EN],
      },
      {
        key: "content",
        value: this.state.values["content"][LANGUAGE_EN],
      },
      {
        key: "duration",
        value: this.state.values["duration"][LANGUAGE_EN],
      },
      {
        key: "entry",
        value: this.state.values["entry"][LANGUAGE_EN],
      },
      {
        key: "additionalDetails",
        value: this.state.values["additionalDetails"][LANGUAGE_EN],
      },
      {
        key: "enrolment",
        value: this.state.values["enrolment"][LANGUAGE_EN],
      },
      {
        key: "cost",
        value: this.state.values["cost"][LANGUAGE_EN],
      },
    ];

    // Add the manual qualificaitons for translation.
    {
      this.state.values.manualQualifications.map((element, index) => {
        data.push({
          key: "manualQualifications." + index + ".title",
          value: FormUtility.getDeepValue(
            this.state.values,
            "manualQualifications." + index + ".title.en"
          ),
        });
      });
    }

    {
      this.state.values.sessions.map((element, index) => {
        data.push({
          key: "sessions." + index + ".startDetails",
          value: FormUtility.getDeepValue(
            this.state.values,
            "sessions." + index + ".startDetails.en"
          ),
        });
        data.push({
          key: "sessions." + index + ".daysTimes",
          value: FormUtility.getDeepValue(
            this.state.values,
            "sessions." + index + ".daysTimes.en"
          ),
        });
      });
    }

    // If work-based learning course then ignore pre-populated fields
    // See https://dev.azure.com/ccdg/CWO%20-%20Courses/_workitems/edit/9270
    if (
      ["267040002", "267040003", "267040004"].includes(
        this.state.values.courseGroup?.type
      )
    ) {
      data = data.filter(
        (field) =>
          !["summary", "duration", "entry", "additionalDetails"].includes(
            field.key
          )
      );
    }

    this.props.translationApiPostTranslation(
      "en",
      "cy",
      data,
      i18n.language,
      (response) => {
        const values = { ...this.state.values };

        response.data.forEach((element, i) => {
          if (element.value !== null) {
            this.handleSetFormValue(element.key + ".cy", element.value);
          }
        });

        this.setState({ values: values });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  /**
   * render.
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <CoursesTranslateView
          {...this.state}
          loadCourse={this.loadCourse}
          saveCourse={this.saveCourse}
          handleChange={this.handleChange}
          handleSetFormValue={this.handleSetFormValue}
          toggleModal={this.toggleModal}
          assignCourse={this.assignCourse}
          compareCourse={this.compareCourse}
          handleBulkCheckbox={this.handleBulkCheckbox}
          clearMessages={this.clearMessages}
          clearSelected={this.clearSelected}
          clearRedirect={this.clearRedirect}
          handleErrorClick={this.handleErrorClick}
          handleClearActiveErrors={this.handleClearActiveErrors}
          translateCourseAll={this.translateCourseAll}
          translateCourseField={this.translateCourseField}
          setReloadKey={this.setReloadKey}
          loadAudit={this.loadAudit}
          setQuery={this.setQuery}
        />
      </Fragment>
    );
  }
}

export default withAuditApi(process.env)(
  withAssets(
    withTranslationApi(process.env)(
      withCoursePortalApi(process.env)(
        withAuthentication(withTranslation("local")(CoursesTranslateController))
      )
    )
  )
);
